import React, { useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { MdOutlineClose, MdOutlineCheck, MdOutlineRefresh, MdOutlineSearch } from "react-icons/md";
import { Input, Button } from "react-daisyui"
import { useBannerStore, BannerStore, BannerStoreContext } from "../store/BannerStore";
import { observer } from "mobx-react";
import { useAuthStore } from "../../Auth/store/Auth";

// const Filter = observer(() => {
//     const store = new BannerStore({
//         isloading:true,
//       });
//     return (
//         <BannerStoreContext.Provider value={store}>
//             <Screen />
//         </BannerStoreContext.Provider>
//     )
// })

// export default Filter;

const Filter = observer(({emptyinput}) => {
    const [searchParams] = useSearchParams();
    const searchParamPage = 1;
    const {Token} = useAuthStore();
    const { 
        setScreen,
        setstatus,
        getBanners,
        getFilterBanner,
        NofilterwithPagination,
        loadTableData,
        setfiltertrue,
        Producttypelist,
        Screen
      } = useBannerStore();

      const Reset=()=>{
        setScreen("")
        setstatus("")
        getBanners(searchParamPage || 1,Token)
        setfiltertrue(false);
    }


    useEffect(() => {
        setScreen("")
        setstatus("")
    },[emptyinput])

    return (
        <>

            <div className="card bg-base-100 shadow-md p-6 mt-3 mb-10">
                <form onSubmit={(e) => {NofilterwithPagination(false);getFilterBanner(searchParamPage || 1,Token);e.preventDefault() }}>
                    <div className="grid lg:grid-cols-3 md:grid-cols-2 md:gap-8 gap-4">
                        <div>
                            <label htmlFor="Screen" className="block text-sm font-semibold text-zinc-700 dark:text-stone-400 mb-2">Screen</label>
                            <select
                                id="screen"
                                name="screen"
                                defaultValue=""
                                onChange={(e)=> {setScreen(e.target.value)} }
                                className={`select focus:outline-0 w-full text-sm font-medium rounded-md focus:outline-offset-0 select-bordered`}>
                                <option value="">All</option>
                                <option value="Friends">Friends</option>
                                <option value="Chat">Chat</option>
                                <option value="Channel">Channel</option>
                            </select>
                        </div>
                        {/* <div>
                            <label htmlFor="keywords" className="block text-sm font-semibold text-zinc-700 dark:text-stone-400 mb-2">Keywords</label>
                            <Input
                                name="keywords"
                                placeholder="keywords"
                                id="keywords"
                                type="text"
                                autoComplete="off"
                                className="focus:outline-0 w-full text-sm font-medium rounded-md"
                            />
                        </div> */}
                        <div>
                            <label htmlFor="Status" className="block text-sm font-semibold text-zinc-700 dark:text-stone-400 mb-2">Status</label>
                            <select
                                id="Status"
                                name="Status"
                                defaultValue=""
                                onChange={(e)=> {setstatus(e.target.value)}}
                                className={`select focus:outline-0 w-full text-sm font-medium rounded-md focus:outline-offset-0 select-bordered`}>
                                <option value="" className="">All</option>
                                <option value="active">Active</option>
                                <option value="in-active">Inactive </option>
                            </select>
                        </div>
                    </div>
                    <div className="lg:mt-3 mt-4 flex items-center md:justify-end justify-between">
                        <button type="reset" onClick={() => { Reset()  }} className="btn btn-md bg-darkgreen text-[#fff] text-sm hover:text-darkgreen hover:bg-lightgreen "><MdOutlineRefresh className="mr-1" />Reset</button>
                        <button type="submit" className="btn btn-md bg-lightgreen text-darkgreen text-sm hover:bg-darkgreen hover:text-[#fff]   ml-4"><MdOutlineSearch className="mr-1" />Search</button>
                    </div>
                </form>
            </div>

        </>
    )
})

export default Filter;
